import React from 'react';
import { panel1Data, panel2Data, priceData1, priceData2, priceData3, priceData4 } from './data';
import './Styles/Panel.scss';

export function Panel1(){
    return(
        <div className="pricing-panel">
            {panel1Data.map((d,i) =>{
                return(
                    <PriceCard key={i} {...d}/>
                )
            })}
        </div>
    )
};
export function Panel2(){
    return(
        <div className="pricing-panel">
            {panel2Data.map((d,i) =>{
                return(
                    <PriceCard key={i} {...d}/>
                )
            })}
        </div>
    )
};


export function PriceCard(props){
    return(
        <div className="price-card">
            <h2>{props.title}</h2>
            <p>{props.desc}</p>
            <h1 data-aos="zoom-in"
              data-aos-delay={100}>{props.price}</h1>
            <button>{props.btn}</button>
            <ul>
                {props.list.map((item) =>{
                    return(
                        <li>
                            <div className="icon">
                                {item.icon}
                            </div>
                            <p>{item.title}</p>
                        </li>
                    )
                })}
            </ul>
        </div>
    )
};